import { describeToolCall } from "../chat/workEntryStep";
import { MORROW_BROWSER_LOGO_URL } from "../chat/morrowBuiltInToolDisplay";

/** Resolve Composio logo + app name from a toolkit slug (e.g. `gmail`, `slack`). */
export function resolveContextToolIcon(toolSlug: string): {
  readonly logoUrl: string | null;
  readonly appName: string | null;
} {
  const normalized = toolSlug.trim().toLowerCase();
  if (!normalized) {
    return { logoUrl: null, appName: null };
  }
  const syntheticToolName = `${normalized.toUpperCase().replace(/[^a-z0-9]/gi, "")}_ACTION`;
  const desc = describeToolCall(syntheticToolName);
  const slug = desc.slug ?? normalized;
  const logoUrl =
    desc.logoUrl ??
    (slug === "browser" ? MORROW_BROWSER_LOGO_URL : `https://logos.composio.dev/api/${slug}`);
  return {
    logoUrl,
    appName: desc.appName,
  };
}
